<!-- src/App.vue -->
<template>
  <div>
    <PortfolioToggle />
    <router-view v-if="!isGraphics" />
    <GraphicsPortfolio v-else />
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import PortfolioToggle from './components/PortfolioToggle.vue'
import GraphicsPortfolio from './view/uiuxPortfolio.vue'

export default {
  name: 'App',
  components: {
    PortfolioToggle,
    GraphicsPortfolio
  },
  setup() {
    const route = useRoute()
    const isGraphics = computed(
      () => route.name === 'Graphics' || route.path === '/graphics'
    )
    return { isGraphics }
  }
}
</script>
